module.exports = __webpack_public_path__ + "static/hooters-f02164ad6818fa4334b7ee45dcedeb60.png";